var _rect, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResIntellAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_res_intell_attach",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 32,
    height: 32,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ebf5ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M-3616.161-4337.236h-8.543a.641.641,0,0,1-.481-.194.644.644,0,0,1-.194-.48v-10.7a.649.649,0,0,1,.194-.482.648.648,0,0,1,.481-.193h8.543a.653.653,0,0,1,.482.193.649.649,0,0,1,.192.482v10.7a.643.643,0,0,1-.192.48A.645.645,0,0,1-3616.161-4337.236Zm-7.868-10.7v9.347h7.193v-9.347Zm.51-3.247h0l-.941-.943a5.964,5.964,0,0,1,1.8-1.161,6.021,6.021,0,0,1,2.3-.452,6.016,6.016,0,0,1,2.3.452,5.974,5.974,0,0,1,1.8,1.161l-.942.943a4.483,4.483,0,0,0-1.376-.868,4.8,4.8,0,0,0-1.785-.339,4.808,4.808,0,0,0-1.785.339,4.5,4.5,0,0,0-1.375.868Zm-2.5-2.5h0l-.979-.98a10.03,10.03,0,0,1,2.97-1.911,9.511,9.511,0,0,1,3.671-.729,9.509,9.509,0,0,1,3.672.729,9.145,9.145,0,0,1,2.93,1.951l-.941.94a7.744,7.744,0,0,0-2.5-1.654,8.325,8.325,0,0,0-3.158-.617,8.317,8.317,0,0,0-3.157.617,7.74,7.74,0,0,0-2.5,1.655Z",
    transform: "translate(3636.377 4363.269)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResIntellAttach);
export default __webpack_public_path__ + "static/media/ic_res_intell_attach.ea6708e9c7d97d5ba79bb60e52ec790c.svg";
export { ForwardRef as ReactComponent };